import { Injectable } from '@angular/core';
import moment from 'moment';
import * as uuid from 'uuid';
import { DispatchDriverSummary } from '../classes/dispatch-driver-summary';
import { DispatchTaskStatus } from '../classes/dispatch-task-status';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  constructor() {}

  public guid(): string {
    return uuid.v4();
  }

  public validateLatLngs(lat, lng): boolean {
    const reg = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/;
    if (reg.test(lat) && reg.test(lng)) {
      return true;
    }
    return false;
  }

  /**
   * Converts a backend date value (array or string) to a moment-parseable value.
   * Backend Joda LocalDateTime serializes as [year, month, day, hour, min, sec, ms]
   * where month is 1-based, but moment arrays expect 0-based months.
   */
  private toMomentDate(value: any): any {
    if (Array.isArray(value)) {
      const [year, month, day, hour = 0, minute = 0, second = 0, ms = 0] = value;
      return new Date(year, month - 1, day, hour, minute, second, ms);
    }
    return value;
  }

  public timeMath = (thisDate: any): any => {
    let dueIn = moment(this.toMomentDate(thisDate)).fromNow(false); // <-- magic
    const dueDate: string[] = [];

    if (dueIn.indexOf('ago') >= 0) {
      //LATE
      dueIn = dueIn
        .replace(/days ago/g, 'days')
        .replace(/hours ago/g, 'hours')
        .replace('an hour ago', '1 hour')
        .replace(/minutes ago/g, 'minutes')
        .replace('a minute ago', '1 minute')
        .replace('a day ago', '1 day')
        .replace('a few seconds ago', '1 minute');

      dueDate.push('LATE');
    } else {
      //EARLY
      dueIn = dueIn
        .replace('in a few seconds', '<1 minute')
        .replace('in a minute', '<1 minute')
        .replace('in ', '')
        .replace('an hour', '1 hour')
        .replace(/minutes/g, 'minutes')
        .replace(/hours/g, 'hours')
        .replace(/days/g, 'days');

      dueDate.push('EARLY');
    }
    dueDate.push(dueIn.split(' ')[0]);
    dueDate.push(dueIn.split(' ')[1]);
    return dueDate;
  };

  getStatusColor(taskGroupStatus: DispatchTaskStatus): string {
    // circles on summary headers
    let circleStyleClass = '';
    switch (taskGroupStatus.trim()) {
      case DispatchTaskStatus.LATE:
        circleStyleClass = 'dispatchDivCircleRed';
        break;
      case DispatchTaskStatus.COMPLETED:
        circleStyleClass = 'dispatchDivCircleGreen';
        break;
      case DispatchTaskStatus.ASSIGNED:
        circleStyleClass = 'dispatchDivCircleGray';
        break;
      case DispatchTaskStatus.UNASSIGNED:
        circleStyleClass = 'dispatchDivCircleBlue';
        break;
      case DispatchTaskStatus.STARTED:
        circleStyleClass = 'dispatchDivCircleOrange';
        break;
      case DispatchTaskStatus.CANCELLED:
        circleStyleClass = 'dispatchDivCircleBlack';
        break;
      case DispatchTaskStatus.NOT_ON_GROUND:
        circleStyleClass = 'dispatchDivCircleWhite';
        break;
    }
    return circleStyleClass;
  }

  getDriverSummaryDisplayName(driverSummary: DispatchDriverSummary): string {
    return `${driverSummary.driverFirstName.charAt(0).toUpperCase()}. ${driverSummary.driverLastName}`;
  }

  formatNotes(notes: string): string {
    return notes && notes.trim().replace('null', '');
  }
}
